var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 22h2V2h-2v9H5.83l5.5-5.5-1.41-1.42L2 12l7.92 7.92 1.41-1.42-5.5-5.5H20z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }